
function onResourceRoleUpdated(event) {

}

export default onResourceRoleUpdated;
